import { render, staticRenderFns } from "./DashboardTeacherCourse.vue?vue&type=template&id=a712fa92&"
import script from "./DashboardTeacherCourse.vue?vue&type=script&lang=ts&"
export * from "./DashboardTeacherCourse.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTeacherCourse.vue?vue&type=style&index=0&id=a712fa92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports